<template>
  <div style="padding: 1em;">
    <v-text-field
      hide-details
      v-model="newOfferField"
      color="deep-purple"
      :label="fieldName"
      rows="3"
      @change="changeValue"
    ></v-text-field>
    <v-btn  style="margin-top: 10px;" v-if="newOfferField !== offerField" @click="onSave()"> Αποθήκευση </v-btn>
  </div>
</template>

<script>
  export default {
    name: "OfferFieldEditor",
    data: () => ({
      newOfferField: null,
      hasChanged: false,

    }),
    props: {offerField:String,fieldName:String},
    mounted(){
      this.newOfferField = this.offerField;
    },
    methods: {
      changeValue() {
        this.hasChanged = true
      },
      onSave(){
        this.hasChanged = false;
        if(!this.newOfferField){
          this.$emit('onSave'," - ")

        }else{
          this.$emit('onSave',this.newOfferField)

        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OfferFieldEditor.vue